import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BusFront, Loader2 } from "lucide-react";
import SearchForm from "@/components/SearchForm";
import TripCard from "@/components/TripCard";
import { api } from "@/lib/api";
import { fmtDate, todayStr } from "@/lib/format";

export default function SearchPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const from = params.get("from"), to = params.get("to"), date = params.get("date") || todayStr();
  const [trips, setTrips] = useState(null);

  useEffect(() => {
    setTrips(null);
    api.get("/public/trips/search", { params: { origin_id: from, destination_id: to, date } }).then((r) => setTrips(r.data)).catch(() => setTrips([]));
  }, [from, to, date]);

  const go = (q) => nav(`/search?from=${q.from}&to=${q.to}&date=${q.date}`);
  const days = Array.from({ length: 7 }, (_, i) => todayStr(i));

  return (
    <div className="hero-bg min-h-full">
      <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
        <SearchForm key={`${from}${to}${date}`} initial={{ from, to, date }} onSearch={go} />
        <div className="no-scrollbar mt-5 flex gap-2 overflow-x-auto pb-1" data-testid="date-strip">
          {days.map((d) => (
            <button key={d} onClick={() => go({ from, to, date: d })} data-testid={`date-chip-${d}`}
              className={`btn-press shrink-0 rounded-xl border px-4 py-2 text-sm font-bold ${d === date ? "border-[#0052FF] bg-[#0052FF] text-white" : "border-slate-200 bg-white text-slate-700 hover:border-blue-300"}`}>
              {d === todayStr() ? "Today" : fmtDate(d)}
            </button>
          ))}
        </div>
        <div className="mt-6 space-y-3" data-testid="trip-results">
          {trips === null && <div className="grid h-40 place-items-center"><Loader2 className="h-6 w-6 animate-spin text-[#0052FF]" /></div>}
          {trips?.length === 0 && (
            <div className="card-soft flex flex-col items-center gap-2 p-10 text-center" data-testid="no-trips-message">
              <BusFront className="h-10 w-10 text-blue-300" />
              <div className="font-display text-lg font-bold">No buses found for this day</div>
              <p className="text-sm text-slate-500">Try another date from the strip above.</p>
            </div>
          )}
          {trips?.length > 0 && <div className="text-sm font-semibold text-slate-600">{trips.length} bus{trips.length > 1 ? "es" : ""} available · {fmtDate(date)}</div>}
          {trips?.map((t) => <TripCard key={t.id} trip={t} onSelect={() => nav(`/trip/${t.id}?from=${t.origin_id}&to=${t.destination_id}`)} />)}
        </div>
      </div>
    </div>
  );
}
